import { JSSStyles } from 'styles/jss';

export const styles: JSSStyles = {
  ImageHotspot: {

  },
};
